/**
 * Plain-sailor tooltip + accessible name for the theme toggle (backlog #24).
 *
 * The pill shows only the state word ("AUTO"/"DAY"/"NIGHT") — this names the
 * control, says what the current mode means, and says the tap cycles modes.
 * The union is written out instead of importing `ThemeMode` from the store so
 * this plain module never depends on a `.svelte.ts` module.
 */
export function themeTitle(mode: 'auto' | 'day' | 'night'): string {
  switch (mode) {
    case 'day':
      return 'Display theme: Day — tap to cycle modes.';
    case 'night':
      return 'Display theme: Night — tap to cycle modes.';
    case 'auto':
    default:
      return 'Display theme: Auto (day and night follow the clock) — tap to cycle modes.';
  }
}
